
<div class="row">
    <div class="col-lg-12">
      <div class="card card-outline-success">
          <div class="card-header">
              <h4 class="m-b-0 text-white">Notificaciones</h4>
          </div>
          <div class="card-body">

              <div *ngFor="let elementoMenu of notificacionesArray" class="list-group">
              <a *ngIf="elementoMenu.iconVisto === 'NOLEIDO'; else noOpaco" style="background-color:rgb(196,205,236,0.2);" routerLink="../{{ elementoMenu.url }}" (click)="setEstatus(elementoMenu.id)" class="list-group-item list-group-item-action flex-column align-items-start">
                    <div class="d-flex w-100 justify-content-between">
                        <i class="mdi mdi-account-plus text-success"></i> <small>{{elementoMenu.tiempo}}</small>
                    </div>
                    
                    <font color="#e33c22">El usuario</font>
                    <font color="#1c2825">{{elementoMenu.user}}</font> <font color="#e33c22">{{elementoMenu.mensaje}}</font>
                    <font color="#1c2825"> {{elementoMenu.sucursalNombre}}</font><i class="mdi mdi-bell-ring text-success"></i>
                  </a>
                
                  <ng-template #noOpaco><a class="list-group-item list-group-item-action flex-column align-items-start" routerLink="../{{ elementoMenu.url }}">
                      <div class="d-flex w-100 justify-content-between">
                          <i class="mdi mdi-account-plus text-success"></i> <small>{{elementoMenu.tiempo}}</small>
                      </div>
                      
                      <font color="#e33c22">El usuario</font>
                      <font color="#1c2825">{{elementoMenu.user}}</font> <font color="#e33c22">{{elementoMenu.mensaje}}</font>
                      <font color="#1c2825"> {{elementoMenu.sucursalNombre}}</font><i class="mdi mdi-bell-outline text-success"></i>
                  </a></ng-template>
                  <div><p></p></div>
                </div>



          </div>
        </div>
      </div>
    </div>



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/notificaciones/notificaciones.component.html